import React from "react";
import "./BookingList.scss";
import { BookingModal} from "./style.js";
import print from "../../../assets/images/print.svg"

const BookingDetail = ({ isOpen, onClose, data }) => {

    if (!isOpen || !data) return null;
  return (
    <BookingModal>
   <div className="booking-section-wrapper">
      <div className="booking-header">
        <h2>Booking ID – TJS103801277402</h2>
        <div className="header-actions">
          <button><img src={print} alt="Print" /> Print Ticket</button>
          <button><img src={print} alt="Invoice" /> Invoice</button>
          <button><img src={print} alt="More" /> More</button>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
      </div>

      <div className="booking-card">
      <div className="card-header-row">
  <div className="card-title">
    <strong>Cart Information :</strong> TJS103801277402
  </div>

  <div className="card-tabs">
    <button className="active">Booking Summary</button>
    <button>History</button>
    <button>Booking Logs</button>
  </div>
</div>


        <div className="card-details">
          <div className="left">
            <div><strong>Booking Id</strong><p>TJS103801277402</p></div>
            <div><strong>Order Type</strong><p>Air</p></div>
            <div><strong>Logged-in User</strong><p>Webetechies Private Limited (112258)</p></div>
            <div><strong>Booking Date</strong><p>Jan 20, 2025 1:03 PM</p></div>
            <div><strong>Amount</strong><p>₹ 3,808.00</p></div>
          </div>
          <div className="separator" />
          <div className="right">
            <div><strong>Status</strong><p>Success</p></div>
            <div><strong>Channel Type</strong><p>API</p></div>
            <div><strong>Booking User</strong><p>Webetechies Private Limited (112258)</p></div>
            <div><strong>Created On</strong><p>Jan 20, 2025 1:03 PM</p></div>
            <div><strong>Flow Type</strong><p>Online</p></div>
          </div>
        </div>
      </div>

      <div className="notes-section">
        <div>Notes (0)</div>
        <button>+ Add Notes</button>
      </div>
      <div className="notes-section">
        <div>Cart Amendments (0)</div>
        <button>+ Raise Amendments</button>
      </div>

<div className="flight_info_container">
  <div className="flight-info">
    <div className="flight-segment">
      <div className="airline-info">
        <img src="/airline-logo.png" alt="Airline" />
        <div>
          <p>Akasa Air QP</p>
          <strong>I5-744-320</strong>
        </div>
      </div>

      <div className="airport-info">
        <p>Indira Gandhi International</p>
        <strong>11:15, Mon 24-Feb</strong>
        <p className="terminal">Terminal 1D</p>
      </div>

      <div className="flight-duration">
        <p>Non Stop</p>
        <div className="duration-line">0h 50m</div>
      </div>

      <div className="airport-info">
        <p>Jaipur Airport, India</p>
        <strong>12:20, Mon 24-Feb</strong>
        <p className="terminal">Terminal T2</p>
      </div>
    </div>
  </div>
<div className="info-conatiner "> 
<div className="passenger-info">
    <div className="left">
      <strong>Last Name/First Name Title</strong>
      <p>1. Singh/Sudhanshu Mr. (A)</p>
    </div>
    <div className="right">
      <div><strong>DOB</strong><p>28/12/1992</p></div>
      <div><strong>Fare Type</strong><p>Published</p></div>
    </div>
  </div>

  <div className="fare-breakup">
    <div className="fare-item"><strong>Base Fare</strong><p>₹ 2,908.00</p></div>
    <div className="fare-item"><strong>Taxes</strong><p>₹ 900.00</p></div>
    <div className="fare-item"><strong>Airline PNR</strong><p>I6QVHS</p></div>
    <div className="fare-item"><strong>GDS PNR</strong><p>-</p></div>
    <div className="fare-item"><strong>Ticket Number</strong><p>-</p></div>
    <div className="fare-item"><strong>Net Fare</strong><p>₹ 3,808.00</p></div>
    <div className="fare-item"><strong>Gross Fare</strong><p>₹ 3,808.00</p></div>
    <div className="fare-item"><strong>Cabin Class</strong><p>ECONOMY</p></div>
    <div className="fare-item"><strong>Booking Class</strong><p>RS</p></div>
    <div className="fare-item"><strong>Fare Basis</strong><p>USAV</p></div>
    <div className="fare-item"><strong>GDS PNR</strong><p>Refundable</p></div>
  </div>

  <div className="less-info">Less Info</div>
</div>
 
    </div>
    <div className="flight_info_container">
    <div className="payment-process">
  <div className="header-row">
    <h3>Payment Process (1)</h3>
    <button className="add-payment">+ Add Payment</button>
  </div>

  <div className="payment-table">
    <div className="payment-row header">
      <span>Created On</span>
      <span>Medium</span>
      <span>Booking Id</span>
      <span>Type</span>
      <span>Credit</span>
      <span>Debit</span>
      <span>Utilization</span>
      <span>Status</span>
    </div>

    <div className="payment-row body">
      <span>Jan 20, 2025 1:03 PM</span>
      <span>Deposit</span>
      <span className="link">TJS103801277402</span>
      <span>Paid For Order</span>
      <span>0.00</span>
      <span>₹3,808.00</span>
      <span></span>
      <span className="status success">Success</span>
    </div>

    <div className="payment-row total">
      <span>Total</span>
      <span></span>
      <span></span>
      <span></span>
      <span>0.00</span>
      <span>₹3,808.00</span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>

    </div>
  

    <div className="user-info">
  <h3>User Information</h3>
  <div className="info-grid">
    <div className="info-item">
      <strong>Contact’s Email</strong>
      <p>sudhanshu@meritpay.co.in</p>
    </div>
    
    <div className="separator"></div>
    
    <div className="info-item">
      <strong>Pax contact</strong>
      <p>+918112659210</p>
    </div>
  </div>
</div>



    </div>
    </BookingModal>
   
  );
};

export default BookingDetail;
